import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import VueGtm from 'vue-gtm';
import VueIntercom from 'vue-intercom';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';
import App from './App.vue';
import router from './router';
import store from './store';
import CallAPI from './plugins/CallAPI';
import './plugins/VeeValidate';
import './plugins/Notifications';
import './plugins/GlobalComponents';

Sentry.init({
	dsn: 'https://dc686bb9eeaf4e7190ecf5dbfd30b310@o440428.ingest.sentry.io/5411573',
	integrations: [
		new VueIntegration({
			Vue,
			tracing: true,
		}),
		new Integrations.BrowserTracing(),
	],
	tracesSampleRate: 1,
	environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
	release: process.env.VUE_APP_SENTRY_RELEASE,
});

Vue.config.productionTip = false;

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Vue.use(VueGtm, {
	id: 'GTM-KSD3CFT',
	enabled: true,
	debug: false,
	vueRouter: router,
});

Vue.use(CallAPI);

Vue.use(VueIntercom, { appId: 'g21s2k3x' });

window.onunhandledrejection = () => {
	Vue.notify({
		duration: 6000,
		type: 'error',
		title: 'Error',
		text: 'Oops! Something went wrong. Please try again.',
	});
};

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
